import {LoadingComponent} from './components/loading/loading.component';
import {InfoButtonComponent} from './components/info-button/info-button.component';
import {SplitterComponent} from './components/splitter/splitter.component';
import {AlphabetizePipe} from './pipes/alphabetize.pipe';
import {PhonePipe} from './pipes/phone-number.pipe';
import {AssetUrlPipe} from './pipes/asset-url.pipe';
import {EmployeeSearchCardComponent} from './components/employee-search-card/employee-search-card.component';
import {EmployeeListComponent} from './components/employee-list/employee-list.component';
import {EmployeeCardComponent} from './components/employee-card/employee-card.component';
import {InlineSVGModule} from 'ng-inline-svg-2';
import {CalendarHeaderComponent} from './components/calendar/calendar-header/calendar-header.component';
import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EmptyRouteComponent} from './empty-route/empty-route.component';
import {CalendarComponent} from './components/calendar/calendar.component';
import {MaterialModule} from './modules/material-module';
import {EmployeeFormComponent} from './components/employee-form/employee-form.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IconComponent} from './components/icon/icon.component';
import {CapacityOverrideCardComponent} from './components/capacity-override-card/capacity-override-card.component';
import {EditCapacityOverrideComponent} from './components/edit-capacity-override/edit-capacity-override.component';
import {ConfirmDialogComponent} from './components/confirm-dialog/confirm-dialog.component';
import {MultiDragDropComponent} from './components/multi-drag-drop/multi-drag-drop.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MinutesToTime} from './pipes/minutes-to-time.pipe';
import {OnofswitchComponent} from './components/onofswitch/onofswitch.component';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {Time12HourFormatPipe} from './pipes/time-12hour-format.pipe';
import {EfcBaseHttpService} from './services/efc-base-http.service';
import {CustomerService} from './services/customer.service';
import {DcsBaseHttpService} from './services/dcs-base-http.service';
import {NotAuthorizedComponent} from './components/not-authorized/not-authorized.component';
import {NgxMatIntlTelInputComponent} from 'ngx-mat-intl-tel-input';
import {EmployeeComponent} from './components/employee/employee.component';
import {ScheduleRotationComponent} from './components/schedule-rotation/schedule-rotation.component';
import {ScheduleListComponent} from './components/schedule-list/schedule-list.component';
import {ScheduleShiftComponent} from './components/schedule-shift/schedule-shift.component';
import {AddItemComponent} from './components/add-item/add-item.component';
import {ScheduleRotationEditComponent} from './components/schedule-rotation-edit/schedule-rotation-edit.component';
import { TimeslotGridComponent } from './components/timeslot-grid/timeslot-grid.component';
import { TransportMaxComponent } from './components/transport-max/transport-max.component';
import { DashboardCalendarComponent } from './components/dashboard-calendar/dashboard-calendar.component';
import { AppointmentByWeekComponent } from './components/dashboard-calendar/appointment-by-week/appointment-by-week.component';
import { AppointmentByDayComponent } from './components/dashboard-calendar/appointment-by-day/appointment-by-day.component';
import { AppointmentCardComponent } from './components/dashboard-calendar/appointment-by-day/appointment-card/appointment-card.component';
import { DayScheduleCardComponent } from './components/dashboard-calendar/appointment-by-week/day-schedule-card/day-schedule-card.component';
import { AppointmentByMonthComponent } from './components/dashboard-calendar/appointment-by-month/appointment-by-month.component';
import { AppointmentListViewComponent } from './components/dashboard-calendar/appointment-list-view/appointment-list-view.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { AppointmentDispatchViewComponent } from './components/dashboard-calendar/appointment-dispatch-view/appointment-dispatch-view.component';
import { CustomCalendarDayViewComponent } from './components/dashboard-calendar/custom-calendar-day-view/custom-calendar-day-view.component';
import { CustomCalendarWeekViewComponent } from './components/dashboard-calendar/custom-calendar-week-view/custom-calendar-week-view.component';
import { AppointmentSummaryDialogComponent } from './components/dashboard-calendar/appointment-summary-dialog/appointment-summary-dialog.component';
import { AddLeavesComponent} from './components/add-leaves/add-leaves.component';
import {AddressComponent} from './components/address/address.component';
import { SwitchCardComponent } from './components/switch-card/switch-card.component';
import { AppointmentTimeComponent } from './components/dashboard-calendar/appointment-summary-dialog/appointment-time/appointment-time.component';
import {FactoryServicesDialogComponent} from './components/factory-services-dialog/factory-services-dialog.component';
import {MessageInfoComponent} from './components/message-info/message-info.component';
import { ConnectStoreDirective } from './components/connect-store-directive/connect-store.directive';
import { BdcCalendarComponent } from '../bdc/shared/calendar/calendar.component';
import { TimeSlotComponent } from './components/time-slot/time-slot.component';
import { AvailabilityComponent } from './components/availability/availability.component';
import { DashboardOverlay } from './components/dashboard-overlay/dashboard-overlay.component';
import { DashboardPrintOverlay } from './components/dashboard-print-overlay/dashboard-print-overlay.component';
import { DashboardOverlayService } from './services/dashboardoverlay.service';
import { AddLeavesService } from './services/add-leaves.service';
import { AspBannerComponent } from './components/asp-banner/asp-banner.component';
import { AspBannerService } from './services/asp-banner.service';
import { VehicleDeliveryComponent } from './components/vehicle-delivery/vehicle-delivery.component'
import { DeliveryChecklistComponent } from './components/delivery-checklist/delivery-checklist.component'
import { OrderByPipe } from './pipes/order-by.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { CustomTranslateFactoryService } from './services/custom-translate-factory.service.ts';
import { TeamMaxComponent } from './components/team-max/team-max.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ScrollDetectionDirective } from './directives/scroll-detection.directive';
import { NgxPrintModule } from 'ngx-print';
import { DoNotModifyBannerComponent } from './components/do-not-modify-banner/do-not-modify-banner.component';
import { PhoneFormatValueAccessor } from './directives/live-phone-format.directive';

@NgModule({
    declarations: [
        EmptyRouteComponent,
        IconComponent,
        EmployeeCardComponent,
        EmployeeSearchCardComponent,
        EmployeeListComponent,
        CalendarComponent,
        CalendarHeaderComponent,
        EmployeeFormComponent,
        CapacityOverrideCardComponent,
        EditCapacityOverrideComponent,
        ConfirmDialogComponent,
        MultiDragDropComponent,
        AssetUrlPipe,
        MinutesToTime,
        OnofswitchComponent,
        PhonePipe,
        Time12HourFormatPipe,
        SplitterComponent,
        InfoButtonComponent,
        EmployeeComponent,
        LoadingComponent,
        NotAuthorizedComponent,
        ScheduleRotationComponent,
        ScheduleListComponent,
        ScheduleShiftComponent,
        AddItemComponent,
        ScheduleRotationEditComponent,
        TimeslotGridComponent,
        TransportMaxComponent,
        DashboardCalendarComponent,
        AppointmentByWeekComponent,
        AppointmentByDayComponent,
        AppointmentCardComponent,
        DayScheduleCardComponent,
        AppointmentByMonthComponent,
        AppointmentListViewComponent,
        AppointmentSummaryDialogComponent,
        AppointmentDispatchViewComponent,
        CustomCalendarDayViewComponent,
        CustomCalendarWeekViewComponent,
        AddLeavesComponent,
        AppointmentTimeComponent,
        AvailabilityComponent,
        DashboardOverlay,
        BdcCalendarComponent,
        TimeSlotComponent,
        ConnectStoreDirective,
        AddressComponent,
        SwitchCardComponent,
        FactoryServicesDialogComponent,
        MessageInfoComponent,
        DashboardPrintOverlay,
        AspBannerComponent,
        VehicleDeliveryComponent,
        DeliveryChecklistComponent,
        OrderByPipe,
        TeamMaxComponent,
        SpinnerComponent,
        ScrollDetectionDirective,
        DoNotModifyBannerComponent,
        PhoneFormatValueAccessor,
        AlphabetizePipe
    ],
    exports: [
        EmployeeListComponent,
        IconComponent,
        EmployeeCardComponent,
        InlineSVGModule,
        EmployeeFormComponent,
        CalendarComponent,
        CapacityOverrideCardComponent,
        AvailabilityComponent,
        DashboardOverlay,
        BdcCalendarComponent,
        TimeSlotComponent,
        LoadingComponent,
        InfoButtonComponent,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        ConfirmDialogComponent,
        MultiDragDropComponent,
        AddItemComponent,
        MinutesToTime,
        PhonePipe,
        OnofswitchComponent,
        InfiniteScrollModule,
        PhonePipe,
        Time12HourFormatPipe,
        InfoButtonComponent,
        ConnectStoreDirective,
        EmployeeComponent,
        ScheduleRotationComponent,
        ScheduleRotationEditComponent,
        ScheduleListComponent,
        ScheduleShiftComponent,
        DragDropModule,
        NgxMatIntlTelInputComponent,
        DashboardCalendarComponent,
        TimeslotGridComponent,
        TransportMaxComponent,
        AppointmentByWeekComponent,
        AppointmentByDayComponent,
        AppointmentCardComponent,
        DayScheduleCardComponent,
        AppointmentByMonthComponent,
        AppointmentListViewComponent,
        AppointmentSummaryDialogComponent,
        AppointmentDispatchViewComponent,
        AddLeavesComponent,
        AppointmentTimeComponent,
        AddressComponent,
        SwitchCardComponent,
        FactoryServicesDialogComponent,
        MessageInfoComponent,
        DashboardPrintOverlay,
        AspBannerComponent,
        VehicleDeliveryComponent,
        DeliveryChecklistComponent,
        OrderByPipe,
        TranslateModule,
        TeamMaxComponent,
        SplitterComponent,
        SpinnerComponent,
        ScrollDetectionDirective,
        DoNotModifyBannerComponent,
        PhoneFormatValueAccessor,
        AlphabetizePipe
    ],
    imports: [
        CommonModule,
        MaterialModule,
        InlineSVGModule.forRoot(),
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory
        }),
        FormsModule,
        ReactiveFormsModule,
        DragDropModule,
        NgxMatIntlTelInputComponent,
        TranslateModule,
        NgxPrintModule
    ],
    providers: [
        EfcBaseHttpService,
        CustomerService,
        DcsBaseHttpService,
        DashboardOverlayService,
        AddLeavesService,
        AspBannerService,
        CustomTranslateFactoryService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
